"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceSystem = void 0;
// sourced from Hydra to maintain case sensitivity
var SourceSystem;
(function (SourceSystem) {
    SourceSystem["CCP"] = "CCP";
    SourceSystem["HAMS"] = "hams";
})(SourceSystem = exports.SourceSystem || (exports.SourceSystem = {}));
